{
  "assistantMemory.title": "Assistant memory and activity",
  "assistantMemory.lede": "Review what the assistant remembers, see what it changed, and trace how AI contributed to a record.",
  "assistantMemory.none": "None",
  "assistantMemory.error.generic": "Assistant memory could not be updated.",
  "assistantMemory.filter.sensitive": "Include sensitive memory",
  "assistantMemory.filter.sensitiveHint": "Sensitive items stay hidden until you choose to reveal them.",
  "assistantMemory.filter.archived": "Include archived memory",
  "assistantMemory.filter.archivedHint": "Show items you previously removed from active use.",
  "assistantMemory.filter.accepted": "Accepted only",
  "assistantMemory.filter.acceptedHint": "Limit this view to memories you explicitly approved.",
  "assistantMemory.memos.title": "Remembered context",
  "assistantMemory.memos.description": "Nothing here is hidden from you. Review, correct, reject, archive, or permanently clear each item.",
  "assistantMemory.empty.title": "No assistant memory in this view",
  "assistantMemory.empty.description": "Change the filters or approve context from an assistant session first.",
  "assistantMemory.memo.meta": "Updated {{updated}} · expires {{expiry}} · revision {{revision}}",
  "assistantMemory.state.proposed": "Needs review",
  "assistantMemory.state.accepted": "Accepted",
  "assistantMemory.state.rejected": "Rejected",
  "assistantMemory.kind.summary": "Summary",
  "assistantMemory.kind.standing_fact": "Standing fact",
  "assistantMemory.sensitivity.normal": "Normal",
  "assistantMemory.sensitivity.private": "Private",
  "assistantMemory.sensitivity.sensitive": "Sensitive",
  "assistantMemory.consent.none": "Not granted",
  "assistantMemory.consent.granted": "Granted",
  "assistantMemory.consent.withdrawn": "Withdrawn",
  "assistantMemory.action.accept": "Accept",
  "assistantMemory.action.reject": "Reject",
  "assistantMemory.action.archive": "Archive",
  "assistantMemory.action.restore": "Restore",
  "assistantMemory.action.clear": "Clear permanently",
  "assistantMemory.action.close": "Close",
  "assistantMemory.action.save": "Save changes",
  "assistantMemory.clear.title": "Permanently clear “{{title}}”?",
  "assistantMemory.clear.description": "This removes the memory immediately and cannot be undone. Related source records are not deleted.",
  "assistantMemory.receipts.title": "Assistant activity receipts",
  "assistantMemory.receipts.description": "A privacy-safe audit trail of assistant operations and the records they affected.",
  "assistantMemory.receipts.unknownOperation": "Unlabelled assistant operation",
  "assistantMemory.receipts.operations": "Operations",
  "assistantMemory.receipts.origin.mcp_runtime": "Server-recorded",
  "assistantMemory.receipts.origin.legacy_client": "Legacy client-reported",
  "assistantMemory.receipts.legacyNotice": "This historical receipt was supplied by a client. Its operation and record claims are retained for continuity but are not server-verified.",
  "assistantMemory.receipts.risk": "Risk {{risk}}",
  "assistantMemory.receipts.meta": "{{date}} · {{entities}} affected records",
  "assistantMemory.receipts.connection": "Connection",
  "assistantMemory.receipts.connectionUnknown": "Unknown connection",
  "assistantMemory.receipts.connectionId": "Connection ID",
  "assistantMemory.receipts.credentialId": "Credential ID",
  "assistantMemory.receipts.credential.none": "No server-verified credential identity was recorded.",
  "assistantMemory.receipts.credential.oauth": "OAuth access",
  "assistantMemory.receipts.credential.derived": "Derived access",
  "assistantMemory.receipts.credential.unknown": "Unknown credential",
  "assistantMemory.receipts.recordedAt": "Recorded at",
  "assistantMemory.receipts.entities": "Affected records ({{count}})",
  "assistantMemory.receipts.noEntities": "No affected record references were recorded.",
  "assistantMemory.receipts.entityRevision": "Revision {{revision}}",
  "assistantMemory.receipts.entityOpen": "Open {{kind}} {{id}}",
  "assistantMemory.receipts.undo.action": "Undo action",
  "assistantMemory.receipts.undo.title": "Undo {{operation}}?",
  "assistantMemory.receipts.undo.description": "Exognitos will run only the safe compensation saved by the server for {{entities}} affected records. It will refuse if that boundary no longer holds.",
  "assistantMemory.receipts.undo.confirm": "Undo action",
  "assistantMemory.receipts.undo.availableUntil": "Available until",
  "assistantMemory.receipts.undo.completed": "Undone",
  "assistantMemory.receipts.undo.completedAt": "Completed",
  "assistantMemory.receipts.undo.expired": "Undo window expired",
  "assistantMemory.receipts.undo.expiredAt": "Expired",
  "assistantMemory.receipts.undo.unavailable": "Automatic undo unavailable",
  "assistantMemory.receipts.undo.error": "The assistant action could not be undone.",
  "assistantMemory.receipts.empty": "No assistant activity receipts yet.",
  "assistantMemory.provenance.title": "Record provenance",
  "assistantMemory.provenance.description": "Look up one record to see whether its content was direct, imported, or assisted by AI.",
  "assistantMemory.provenance.entityType": "Record type",
  "assistantMemory.provenance.entityId": "Record ID",
  "assistantMemory.provenance.lookup": "Trace record",
  "assistantMemory.provenance.empty": "No provenance entries were found for this record.",
  "assistantMemory.provenance.contribution": "AI contribution: {{contribution}} · provider: {{provider}} · model: {{model}}",
  "assistantMemory.edit.title": "Review assistant memory",
  "assistantMemory.edit.description": "Your edit and consent choices replace the current assistant-held version.",
  "assistantMemory.edit.memoTitle": "Memory title",
  "assistantMemory.edit.body": "Remembered context",
  "assistantMemory.edit.sensitivity": "Sensitivity",
  "assistantMemory.edit.consent": "Consent to use",
  "assistantMemory.edit.expiresAt": "Expires at",
  "assistantMemory.edit.reviewAt": "Review again at",
  "assistantMemory.edit.sourceTitle": "Source and revision",
  "assistantMemory.edit.sourceDescription": "Based on {{count}} source references. Current revision: {{revision}}."
}
